/**
 * Section anchors are a core invariant of the content model: every section
 * carries a stable, canonical anchor used for in-page navigation, edit
 * addressing, and parity checks.
 */

/**
 * Normalize a section anchor to the canonical form used across the
 * content model: lowercase ASCII, words separated by single hyphens.
 * Czech (and other Latin-script) diacritics are transliterated, not
 * dropped ("Otevírací doba" -> "oteviraci-doba").
 */
export function normalizeAnchor(raw: string): string {
  return raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    // The collapse above leaves at most ONE hyphen at each edge, so
    // single-char anchored trims suffice (avoids S8786 backtracking).
    .replace(/^-/, '')
    .replace(/-$/, '');
}

/** True when the string is already in canonical anchor form (non-empty). */
export function isCanonicalAnchor(anchor: string): boolean {
  return anchor.length > 0 && normalizeAnchor(anchor) === anchor;
}
